var _metadata, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssisChatBot = function SvgAssisChatBot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60mm",
    height: "60mm",
    viewBox: "0 0 60 60",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    dur: "10s",
    from: "0 30 30",
    repeatCount: "indefinite",
    to: "360 30 30",
    type: "rotate"
  }), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    d: "m30 1.1122e-8a30 30 0 0 0-3.097 0.1602l3.097 0.0052 2.9828-0.01654a30 30 0 0 0-2.9828-0.14883zm-26.005 15.041a30 30 0 0 0-3.9956 14.959 30 30 0 0 0 30 30 30 30 0 0 0 30-30 30 30 0 0 0-3.9956-14.959 30 29.834 0 0 1-10.923 10.915 30 29.834 0 0 1-30.063 0.057878 30 29.834 0 0 1-11.023-10.973z",
    fill: "#3bb7e4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-2",
    d: "m30 0a30 30 0 0 0-18.667 6.5143 29.834 30 0 0 1 14.622 8.4041 29.834 30 0 0 1 0.05788 30.063 29.834 30 0 0 1-14.674 8.5096 30 30 0 0 0 18.66 6.5092 30 30 0 0 0 30-30 30 30 0 0 0-30-30zm-29.851 27.017a30 30 0 0 0-0.14883 2.9833 30 30 0 0 0 0.1602 3.0965l0.0052-3.0965z",
    fill: "#3b8ce4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-3",
    d: "m30 0a30 30 0 0 0-30 30 30 30 0 0 0 3.9956 14.958 30 29.834 0 0 1 10.923-10.915 30 29.834 0 0 1 30.063-0.057877 30 29.834 0 0 1 11.023 10.973 30 30 0 0 0 3.9956-14.959 30 30 0 0 0-30-30zm0 59.835-2.9833 0.01654a30 30 0 0 0 2.9833 0.14883 30 30 0 0 0 3.0965-0.1602z",
    fill: "#3c3be4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-4",
    d: "m30 0a30 30 0 0 0-30 30 30 30 0 0 0 30 30 30 30 0 0 0 15-4.0194 30 30 0 0 1-10.933-10.899 30 30 0 0 1-0.058394-30.063 30 30 0 0 1 10.992-10.999 30 30 0 0 0-15-4.0194z",
    fill: "#0302af"
  })), /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    d: "m30 1.1122e-8a30 30 0 0 0-3.097 0.1602l3.097 0.0052 2.9828-0.01654a30 30 0 0 0-2.9828-0.14883zm-26.005 15.041a30 30 0 0 0-3.9956 14.959 30 30 0 0 0 30 30 30 30 0 0 0 30-30 30 30 0 0 0-3.9956-14.959 30 29.834 0 0 1-10.923 10.915 30 29.834 0 0 1-30.063 0.057878 30 29.834 0 0 1-11.023-10.973z",
    fill: "#3bb7e4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-2",
    d: "m30 0a30 30 0 0 0-18.667 6.5143 29.834 30 0 0 1 14.622 8.4041 29.834 30 0 0 1 0.05788 30.063 29.834 30 0 0 1-14.674 8.5096 30 30 0 0 0 18.66 6.5092 30 30 0 0 0 30-30 30 30 0 0 0-30-30zm-29.851 27.017a30 30 0 0 0-0.14883 2.9833 30 30 0 0 0 0.1602 3.0965l0.0052-3.0965z",
    fill: "#3b8ce4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-3",
    d: "m30 0a30 30 0 0 0-30 30 30 30 0 0 0 3.9956 14.958 30 29.834 0 0 1 10.923-10.915 30 29.834 0 0 1 30.063-0.057877 30 29.834 0 0 1 11.023 10.973 30 30 0 0 0 3.9956-14.959 30 30 0 0 0-30-30zm0 59.835-2.9833 0.01654a30 30 0 0 0 2.9833 0.14883 30 30 0 0 0 3.0965-0.1602z",
    fill: "#3c3be4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-4",
    d: "m30 0a30 30 0 0 0-30 30 30 30 0 0 0 30 30 30 30 0 0 0 15-4.0194 30 30 0 0 1-10.933-10.899 30 30 0 0 1-0.058394-30.063 30 30 0 0 1 10.992-10.999 30 30 0 0 0-15-4.0194z",
    fill: "#0302af"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssisChatBot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assis-chat-bot.71f69d5c.svg";
export { ForwardRef as ReactComponent };